'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { FaRegCirclePlay } from 'react-icons/fa6';
import VideoModal from '../videoModal/videoModal';

interface WhySignupVideoProps {
  videoUrl: string;
  imageSrc: string;
  blurDataURL: string;
}
export default function WhySignupVideo({
  videoUrl,
  imageSrc,
  blurDataURL,
}: WhySignupVideoProps) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="videoWrap">
      <Link
        href="#"
        role="button"
        aria-label="Play video"
        onClick={(e) => {
          e.preventDefault();
          setModalShow(true);
        }}
      >
        <Image
          src={imageSrc}
          alt="Thumbnail image for video"
          sizes="(max-width: 767px) 100vw, 70vw"
          width={700}
          height={500}
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
        <span
          className="playIcon"
          style={{ fontSize: '88px' }}
          aria-hidden="true"
        >
          <FaRegCirclePlay />
        </span>
      </Link>
      <span className="square-pattern" aria-hidden="true"></span>
      <VideoModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videoUrl={videoUrl}
      />
    </div>
  );
}
